import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CacheService } from '../../shared/services/cache.service';
import { StoreConfig } from '../../shared/interfaces/store-config.interface';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { map, catchError } from 'rxjs/internal/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable()
export class ConfigurationService {
    private _attributes: any[] = [];
    private _config: StoreConfig;
    attributeList: any[] = [];

    constructor(private httpClient: HttpClient,
        private _cacheService: CacheService) { }

    /**
     * To handle the obervable error response
     * @param  {Response|any} error
     */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }

    getStoreData(): StoreConfig {
        if (this._config != null) {
            this._config.ccNumberDecimals = 3;
            this._config.ccNumberFormat = 'CR';
            this._config.ccSymbol = 'CC';
            return this._config;
        } else {
            this._config = this._cacheService.get(CacheKey.StoreConfiguration);
            this._config.ccNumberDecimals = 3;
            this._config.ccNumberFormat = 'CR';
            this._config.ccSymbol = 'CC';
            return this._config;
        }
    }

    /**
    * To get country by id
    * @returns Observable
    */
    getCountryByCountryId(id: number): Observable<any> {
        const getCountryUrl = ApiUrlConstants.configurationApiUrl + 'countries/' + id;
        return this.httpClient
            .get(decodeURIComponent(encodeURIComponent(getCountryUrl)))
            .pipe(catchError(this.handleErrorObservable));
    }

    getStoreByCountry(countryCode: string): Observable<any> {
        const getConfigurationUrl = ApiUrlConstants.configurationApiUrl + 'store-countries/' + countryCode;
        return this.httpClient
            .get(decodeURIComponent(encodeURIComponent(getConfigurationUrl)))
            .pipe(catchError(this.handleErrorObservable));;
    }
    private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return throwError(errorMessage);
    }

}
